import { VStack, Icon, Text, Wrap } from '@chakra-ui/react';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import DirectionsWalkRoundedIcon from '@mui/icons-material/DirectionsWalkRounded';
import ConnectWithoutContactRoundedIcon from '@mui/icons-material/ConnectWithoutContactRounded';

import css from './../ListingPage.module.css';
import React from 'react';

const howToJoinOptions = [
  {
    field: 'visitWebsite',
    label: 'Visit website',
    icon: <DevicesRoundedIcon fontSize={'large'} />,
  },
  {
    field: 'walkIn',
    label: 'Walk in',
    icon: <DirectionsWalkRoundedIcon fontSize={'large'} />,
  },
  {
    field: 'contactDirectly',
    label: 'Contact directly',
    icon: <ConnectWithoutContactRoundedIcon fontSize={'large'} />,
  },
];

const SectionHowToJoin = ({ publicData }) => {
  return (
    publicData?.howToJoin?.length > 0 && (
      <section id={'how-to-join'} className={css.howToJoinSection}>
        <h2 className={css.sectionHeading}>How to join</h2>
        <Wrap gap={{ mdDown: 1.5, base: 5 }} mb={'0.5rem'} justify={['center', 'flex-start']}>
          {howToJoinOptions.map(howToJoin => {
            const isActive = publicData?.howToJoin?.includes(howToJoin.field);

            return (
              <VStack
                key={howToJoin.field}
                bgColor={isActive ? 'brand.50' : 'brand.50'}
                borderWidth={'0.2rem'}
                borderColor={isActive ? 'brand.800' : 'transparent'}
                p={{ mdDown: '0.5rem', base: '2rem' }}
                gap={1}
                rounded={'lg'}
                align={'center'}
                justify={'center'}
              >
                <Icon color={isActive ? 'brand.800' : 'brand.100'}>{howToJoin.icon}</Icon>
                <Text
                  color={isActive ? 'brand.800' : 'brand.100'}
                  fontWeight={{ mdDown: 'semibold', base: 'bold' }}
                  m={0}
                >
                  {howToJoin.label}
                </Text>
              </VStack>
            );
          })}
        </Wrap>
      </section>
    )
  );
};

export default SectionHowToJoin;
